import { render } from "./hardware_x_body_banner7.vue?vue&type=template&id=7f64dffd&scoped=true"
import script from "./hardware_x_body_banner7.vue?vue&type=script&lang=js"
export * from "./hardware_x_body_banner7.vue?vue&type=script&lang=js"

import "./hardware_x_body_banner7.vue?vue&type=style&index=0&id=7f64dffd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f64dffd"]])

export default __exports__